import React, { useContext, useEffect, useState, useMemo } from "react";
import useAxiosPrivate from "../../../Hooks/useAxiosPrivate";
import { RESULT_STATUS } from "../../../constants";
import Table from "../../CommonComponents/Table";
import useAuth from "../../../Hooks/useAuth";
import Loading from "../../Notification-Loading/Loading/Loading";
import SharedScopeTitle from "../../CommonComponents/SharedScopeTitle";
import SharedScopeBadge from "../../CommonComponents/SharedScopeBadge";
import SharedScopeEdit from "../../CommonComponents/SharedScopeEdit";
import UniversityListHooks from "../../../Hooks/UniversityListHooks";
import AlertContext from "../../../context/AlertContext";
import SharedScopePreview from "../../CommonComponents/SharedScopePreview";
import { isGradiousAdmin } from "../../../util";

// All available columns
const allColumns = [
  {
    key: "name",
    title: "Name",
    className: "admin-path-list-item-name",
  },
  {
    key: "description",
    title: "Description",
    className: "admin-path-list-item-description",
  },
  {
    key: "preview",
    title: "",
    className: "preview"
  },
  {
    key: "shareScope",
    title: <SharedScopeTitle />,
    className: "shareScope"
  },
  {
    key: "edit",
    title: "",
    className: "edit"
  },
  {
    key: "createdby",
    title: "Createdby",
    className: "admin-path-list-item-createdby",
  },
];

const SharedPaths = ({ searchValue }) => {
  const { selectedScope } = useContext(AlertContext);
  const axios = useAxiosPrivate();
  const UniversityListHks = UniversityListHooks();
  const { navigate, setIsLoaded, isLoaded, setShowNotify } = useAuth();

  const GradiousAdmin = useMemo(() => isGradiousAdmin(), []);

  // Filter columns based on GradiousAdmin
  const columns = GradiousAdmin
    ? allColumns.filter(col => !["description"].includes(col.key))
    : allColumns.filter(col => !["shareScope", "edit", "createdby"].includes(col.key));

  const [paths, setPaths] = useState([]);
  const [filteredPaths, setFilteredPaths] = useState([]);

  useEffect(() => {

    fetchPaths();
  }, [axios, setIsLoaded, setShowNotify, selectedScope]);

  useEffect(() => {
    UniversityListHks.fetchUniversities();
  }, []);

  useEffect(() => {
    setFilteredPaths(() =>
      paths.filter((item) =>
        item.name.toLowerCase().includes(searchValue.toLowerCase())
      )
    );
  }, [searchValue, paths]);

  const fetchPaths = async () => {
    try {
      setIsLoaded(true);
      const { data } = await axios.get(
        `node/admin/learningpath?scope=${selectedScope?.toLowerCase()}&&archived=${false}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("data", data);
      if (data?.resultCode === RESULT_STATUS.SUCCESS) {
        let response = data?.data || [];
        response = response.map((item) => {
          if (!item.createdby || item.createdby === "null")
            item.createdby = "-";
          if (item.share_scope) item.shareScope = item.share_scope;
          if (item.sharedCompanies) item.sharedCompanies = typeof item.sharedCompanies === "string" ? JSON.parse(item.sharedCompanies) : item.sharedCompanies;
          return item;
        });
        setPaths(response);
        setFilteredPaths(response);
      } else {
        setShowNotify({
          title: "Warning !",
          msg:
            data?.msg ??
            `Unable to get the path list. Please try again later`,
          show: true,
        });
      }
    } catch (error) {
      console.error("error in fetch paths", error);
      let isUnAuth = error.message.includes("403");
      setShowNotify({
        isUnAuth,
        title: isUnAuth ? "Warning !" : "Error !",
        msg: isUnAuth
          ? "You have been logged-out due to inactivity. Login again."
          : error.message ??
          `Unable to get the path list. Please try again later`,
        show: true,
      });
    } finally {
      setIsLoaded(false);
    }
  };
  const handleScopeUpdateInUI = (lpId, newScope, updatedCompanies) => {
    console.log("learningPath", lpId, newScope, updatedCompanies);
    // Update the local state so the UI reflects the change immediately
    fetchPaths();
    // setPaths(prev => prev.map(item =>
    //   item.id === lpId ? { ...item, shareScope: newScope, sharedCompanies: updatedCompanies } : item
    // ));
  };

  // Custom row render function
  const renderCustomRow = (row, rowIndex, columns) => {
    return (
      <tr
        key={rowIndex}
        className="tableBodyRow"
        onClick={() => navigate(`/learningpath/${row.id}`)}
      >
        {columns.map((col, colIndex) => (
          <td
            key={colIndex}
            className={`tableData ${col.key} ${!["topic", "total"].includes(col.key)
              ? "topicComplexity"
              : col.key === "total"
                ? "topicTotal"
                : col.key === "shareScope"
                  ? "shareScope"
                  : ""
              }`}
          >
            {col.key === "shareScope" ? (
              <div onClick={(e) => e.stopPropagation()}>
                <SharedScopeBadge
                  shareScope={row.shareScope}
                  sharedCompanies={row.sharedCompanies}
                />
              </div>
            ) : col.key === "edit" ? (
              <div className="editIcon" onClick={(e) => e.stopPropagation()}>
                <SharedScopeEdit
                  selectedRow={row}
                  onUpdateSuccess={handleScopeUpdateInUI}
                  from="learningpath"
                />
              </div>
            ) : col.key === "preview" ? (
              <div
                className="editIcon"
                onClick={(e) => {
                  e.stopPropagation();
                  window.open(`/preview/home/${row.id}/module?mode=previewlp`, "_blank");
                }}
              >
                <SharedScopePreview />
              </div>
            ) : (
              row[col.key]
            )}
          </td>
        ))}
      </tr>
    );
  };

  if (isLoaded) return <Loading />;

  return (
    <div className="admin-path-list-container admin-sharedpath-list-container">
      <Table
        columns={columns}
        fixedHeader
        bordered
        data={filteredPaths}
        renderRow={renderCustomRow}
        className="admin-path-list-table"
        noDataMsg="No shared learning paths found."
        onClickRow={(row) => navigate(`/learningpath/${row.id}`)}
      />

    </div>
  );
};

export default SharedPaths;
